import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { GetPatientResponse } from '../services/patientCard';
import { patientCardQuery } from './patientCardQuery';
import { PATIENT_CARD_KEY } from './queryKeys';

export function usePatientCard(patientId: string | undefined) {
    const queryClient = useQueryClient();

    const { data, error, isLoading } = useQuery<GetPatientResponse>({
        ...patientCardQuery(patientId ?? ''),
        enabled: !!patientId,
        staleTime: 5 * 60 * 1000
    });

    const refetch = useCallback(async () => {
        await queryClient.invalidateQueries({ queryKey: PATIENT_CARD_KEY(patientId) });
    }, [queryClient, patientId]);

    return { data: data ?? null, isLoading, error, refetch };
}
